/** @format */

import {useCallback, useState} from 'react';
import Tippy from '@tippyjs/react';

export function Tooltip({placement, maxWidth, content, children, ...props}) {
    const [visible, setVisible] = useState(false);

    const box = useCallback(
        attrs => {
            return (
                visible && (
                    <TooltipBox {...attrs} placement={attrs['data-placement']} maxWidth={maxWidth}>
                        {content}
                    </TooltipBox>
                )
            );
        },
        [content, maxWidth, visible]
    );

    return (
        <Tippy
            placement={placement}
            onShow={() => setVisible(true)}
            onHide={() => setVisible(false)}
            render={box}
            {...props}>
            {children}
        </Tippy>
    );
}

export function TooltipBox({children, placement, maxWidth}) {
    return (
        <div
            className={`tooltip tooltip--placement-${placement} bg-content-black color-content-white py-2 px-3`}
            style={{maxWidth: maxWidth}}>
            <div className="tooltip__arrow" data-popper-arrow=""></div>
            {children}
        </div>
    );
}
